import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HEALTH = {
  nickname: 'PRODUCTS.HEALTH.nickname',
  properties: [
    {
      name: 'continuedInsurance', key: 'CONTINUED_INSURANCE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isPropertyHidden: true,
      isContinuedHealthInsuranceCheck: true,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'clientSsn', key: 'SSN', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      isPropertyHidden: true,
      validator: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{11}$')
      ]]
    },
    {
      name: 'clientDob', key: 'DOB', group: 'OBJECT_INFO',
    },
    {
      name: 'clientName', key: 'NAME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'clientSurname', key: 'SURNAME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_HEALTH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ADULT_10_20_DAYS', value: 'ADULT_10_20_DAYS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ADULT_7_10_DAYS', value: 'ADULT_7_10_DAYS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ADULT_INCL_5_PT_7_10_DAYS', value: 'ADULT_INCL_5_PT_7_10_DAYS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.CHILDREN_10_20_DAYS', value: 'CHILDREN_10_20_DAYS' }
        ]
      }
    },
    {
      name: 'specialsForInsurance', key: 'SPECIALS_FOR_INSURANCE', group: 'INSURANCE_INFO',
      isPropertyHidden: true,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
  ],
  icon:'health'
};
